
import { useParams } from "react-router-dom";
import { DisenioPlanilla } from "../../layout"
import { useCarguerosXPlanilla } from "../../../hooks";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { CargandoMedio } from "../../components";
import { separadorMillares } from "../../../helpers";






export const ListadoCargueros = () => {


    const { id } = useParams();
    const { carguerosXPlanilla } = useCarguerosXPlanilla(`${id}`);


    return (
        <DisenioPlanilla titulo="Listado de Cargueros">
            {(carguerosXPlanilla.isLoading)
            ?   <CargandoMedio titulo="Cargando Cargueros..." />
            :   <Paper sx={{width:'100%', maxWidth:{xs:450, sm:'100%', md:'100%'}, overflowX:'auto'}}>
                    <TableContainer>
                        <Table sx={{minWidth:700, overflowX:'auto'}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{width:'5%'}}>#</TableCell>
                                    <TableCell sx={{width:'35%'}}>NOMBRE</TableCell>
                                    <TableCell sx={{width:'30%'}}>MOVIL</TableCell>
                                    <TableCell sx={{width:'25%'}}>VALOR</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {carguerosXPlanilla.data.length > 0 ? (
                                carguerosXPlanilla.data.map((item, index) => (
                                    <TableRow key={item.id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>{item?.usuario?.nombre}</TableCell>
                                        <TableCell>{item?.usuario?.movil}</TableCell>
                                        <TableCell>{`$${separadorMillares(item.valor)}`}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow><TableCell colSpan={4} style={{ textAlign: 'center' }}>
                                        No hay cargueros en el momento...
                                </TableCell></TableRow>
                            )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            }
        </DisenioPlanilla>


    )
}
